import { reactive } from "vue";

export interface HasCustomOptions
{
    customOptions?: any[] | null;
}

export function createTriggerComponentCtx<T extends object>(
    base: object,
    extra?: T
)
{
    return reactive({
        ...base,
        ...(extra ?? {}),
    }) as T & typeof base;
}
